export default {
  measures: [],
  measure: null,
  pagination: {}
}
